import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { siteData, deviceLst, Orders, caseList } from '../searchTypes'

type SearchItemType = siteData | deviceLst | Orders | caseList

interface SearchDetailModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  item: SearchItemType | null
  type: 'site' | 'device' | 'order' | 'case' | null
}

export function SearchDetailModal({
  open,
  onOpenChange,
  item,
  type,
}: SearchDetailModalProps) {
  if (!item || !type) return null

  const renderContent = () => {
    switch (type) {
      case 'site': {
        const site = item as siteData
        return (
          <div className='space-y-3'>
            <div>
              <p className='text-sm text-secondary-foreground'>Customer ID</p>
              <p className='text-base font-medium text-primary-foreground'>
                {site.value.customerId || 'N/A'}
              </p>
            </div>
            <div>
              <p className='text-sm text-secondary-foreground'>Site ID</p>
              <p className='text-base font-medium text-primary-foreground'>
                {site.value.siteId || 'N/A'}
              </p>
            </div>
            <div>
              <p className='text-sm text-secondary-foreground'>Name</p>
              <p className='text-base font-medium text-primary-foreground'>
                {site.value.name || 'N/A'}
              </p>
            </div>
            <div>
              <p className='text-sm text-secondary-foreground'>Address</p>
              <p className='text-base font-medium text-primary-foreground'>
                {site.value.address || 'N/A'}
              </p>
            </div>
          </div>
        )
      }
      case 'device': {
        const device = item as deviceLst
        return (
          <div className='space-y-3'>
            <div>
              <p className='text-sm text-secondary-foreground'>Line ID</p>
              <p className='text-base font-medium text-primary-foreground'>
                {device.value.lineId || 'N/A'}
              </p>
            </div>
            <div>
              <p className='text-sm text-secondary-foreground'>Site ID</p>
              <p className='text-base font-medium text-primary-foreground'>
                {device.value.siteId || 'N/A'}
              </p>
            </div>
            <div>
              <p className='text-sm text-secondary-foreground'>Customer ID</p>
              <p className='text-base font-medium text-primary-foreground'>
                {device.value.customerId || 'N/A'}
              </p>
            </div>
            <div>
              <p className='text-sm text-secondary-foreground'>Name</p>
              <p className='text-base font-medium text-primary-foreground'>
                {device.value.name || 'N/A'}
              </p>
            </div>
            <div>
              <p className='text-sm text-secondary-foreground'>Circuit ID</p>
              <p className='text-base font-medium text-primary-foreground'>
                {device.value.circuitId || 'N/A'}
              </p>
            </div>
            <div>
              <p className='text-sm text-secondary-foreground'>Address</p>
              <p className='text-base font-medium text-primary-foreground'>
                {device.value.address || 'N/A'}
              </p>
            </div>
            <div>
              <p className='text-sm text-secondary-foreground'>Service Type</p>
              <p className='text-base font-medium text-primary-foreground'>
                {device.value.serviceType || 'N/A'}
              </p>
            </div>
            <div>
              <p className='text-sm text-secondary-foreground'>Node ID</p>
              <p className='text-base font-medium text-primary-foreground'>
                {device.value.nodeId || 'N/A'}
              </p>
            </div>
            <div>
              <p className='text-sm text-secondary-foreground'>LAN IP</p>
              <p className='text-base font-medium text-primary-foreground'>
                {device.value.lanIp || 'N/A'}
              </p>
            </div>
          </div>
        )
      }
      case 'order': {
        const order = item as Orders
        return (
          <div className='space-y-3'>
            <div>
              <p className='text-sm text-secondary-foreground'>Order ID</p>
              <p className='text-base font-medium text-primary-foreground'>
                {order.value.orderId || 'N/A'}
              </p>
            </div>
            <div>
              <p className='text-sm text-secondary-foreground'>Customer ID</p>
              <p className='text-base font-medium text-primary-foreground'>
                {order.value.customerId || 'N/A'}
              </p>
            </div>
            <div>
              <p className='text-sm text-secondary-foreground'>Site ID</p>
              <p className='text-base font-medium text-primary-foreground'>
                {order.value.siteId || 'N/A'}
              </p>
            </div>
            <div>
              <p className='text-sm text-secondary-foreground'>Company Name</p>
              <p className='text-base font-medium text-primary-foreground'>
                {order.value.companyName || 'N/A'}
              </p>
            </div>
            <div>
              <p className='text-sm text-secondary-foreground'>PON</p>
              <p className='text-base font-medium text-primary-foreground'>
                {order.value.pon || 'N/A'}
              </p>
            </div>
            <div>
              <p className='text-sm text-secondary-foreground'>
                Circuit Number
              </p>
              <p className='text-base font-medium text-primary-foreground'>
                {order.value.circuitNumber || 'N/A'}
              </p>
            </div>
            <div>
              <p className='text-sm text-secondary-foreground'>Status</p>
              <p className='text-base font-medium text-primary-foreground'>
                {order.value.status || 'N/A'}
              </p>
            </div>
            <div>
              <p className='text-sm text-secondary-foreground'>
                Order Tracking Number
              </p>
              <p className='text-base font-medium text-primary-foreground'>
                {order.value.orderTrackingNumber || 'N/A'}
              </p>
            </div>
          </div>
        )
      }
      case 'case': {
        const caseItem = item as caseList
        return (
          <div className='space-y-3'>
            <div>
              <p className='text-sm text-secondary-foreground'>Case Number</p>
              <p className='text-base font-medium text-primary-foreground'>
                {caseItem.value.caseNumber || 'N/A'}
              </p>
            </div>
            <div>
              <p className='text-sm text-secondary-foreground'>Account Name</p>
              <p className='text-base font-medium text-primary-foreground'>
                {caseItem.value.accountName || 'N/A'}
              </p>
            </div>
            <div>
              <p className='text-sm text-secondary-foreground'>Site ID</p>
              <p className='text-base font-medium text-primary-foreground'>
                {caseItem.value.siteId || 'N/A'}
              </p>
            </div>
            <div>
              <p className='text-sm text-secondary-foreground'>Customer ID</p>
              <p className='text-base font-medium text-primary-foreground'>
                {caseItem.value.customerId || 'N/A'}
              </p>
            </div>
            <div>
              <p className='text-sm text-secondary-foreground'>Subject</p>
              <p className='text-base font-medium text-primary-foreground'>
                {caseItem.value.subject || 'N/A'}
              </p>
            </div>
            <div>
              <p className='text-sm text-secondary-foreground'>Case Type</p>
              <p className='text-base font-medium text-primary-foreground'>
                {caseItem.value.caseType || 'N/A'}
              </p>
            </div>
          </div>
        )
      }
      default:
        return null
    }
  }

  const getTitle = () => {
    switch (type) {
      case 'site':
        return 'Site Details'
      case 'device':
        return 'Device Details'
      case 'order':
        return 'Order Details'
      case 'case':
        return 'Case Details'
      default:
        return 'Details'
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='max-w-[20rem] max-h-[25rem] bg-primary p-4 rounded-xl'>
        <DialogHeader className='border-b border-secondary-border pb-4 text-[18px] text-primary-foreground'>
          <DialogTitle>{getTitle()}</DialogTitle>
        </DialogHeader>
        <div className='max-h-[19rem] overflow-y-auto spec-scroll scrollbar-hide'>
          {renderContent()}
        </div>
      </DialogContent>
    </Dialog>
  )
}
